import React, { Fragment, useState, useRef } from 'react'
import { toAbsoluteUrl } from '../../services'
import { Box } from '@mui/material'
import QueryForm from '../../free/pages/support/QueryForm';
import { Dialog, Transition } from '@headlessui/react'


function HelpButton(props) {

    const [open, setOpen] = useState(false)
    const cancelButtonRef = useRef(null)

    const handleButtonClick = () => {
        setOpen(true)
    };

    return (
        <>
            <Box className='fixed z-20 right-4' sx={{ bottom: '0px' }}>
                <button style={{ width: '100px' }} onClick={handleButtonClick} className='help--button'>
                    <img src={toAbsoluteUrl(`/media/login/help_icon.svg`)} alt='help icon' />
                </button>
            </Box>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg transition-all ">
                                    <QueryForm screen={props.screen} />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>


            </Transition.Root>

        </>
    )
}

export default HelpButton